import React from "react";
import { BrowserRouter } from "react-router-dom";

import RoutesList from "../../routes";
import CentralLoader from "./CentralLoader";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <RoutesList></RoutesList>
      <CentralLoader />
    </BrowserRouter>
  );
};

export default App;
